import { Component, inject, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-tabbar',
  templateUrl: './tabbar.component.html',
  styleUrls: ['./tabbar.component.scss'],
})
export class TabbarComponent  implements OnInit {

  nav = inject(NavController);
  userService = inject(UserService);
  selectedPath: string = "home";
  activeRoute:String = '/home'
  constructor(private route:Router) {
    this.route.events.subscribe(event=>{
      if(event instanceof NavigationStart){
        this.activeRoute = event.url
      }
    })

  }

  ngOnInit() {}

  async click(path: string, requireLogin = false) {
    console.log("clicked!");
    if (requireLogin) {
      const isVirtual = this.userService.user.isVirtual;
      if (isVirtual) {
        await this.userService.showLoginDialog();
        return;
      }
    }

    this.selectedPath = path;
    this.nav.navigateForward(path);
  }

}
